// Sweet Alert
import sweetalert2 from "sweetalert2";
window.Swal = sweetalert2
